import React, { useEffect } from "react";
import { useSEO } from "../../context/SEOContext";
import { Swiper, SwiperSlide } from "swiper/react";

import { FreeMode, Pagination } from "swiper/modules";
import "./InstallmentOptions.css";
import InstallmentData from "../../api/InstallmentOptions"; // doğru yoldan import etmeyi unutma
import { useTranslation } from "react-i18next";
const InstallmentOptions = () => {
  const { t } = useTranslation();
  const setSeo = useSEO();
  useEffect(() => {
    setSeo({
      title: t("installment.meta.title"),
      description: t("installment.meta.description"),
      keywords: t("installment.meta.keywords"),
      favicon: "/faviconnew.png",
    });
  }, [setSeo, t]);
  return (
    <div className="container py-5 mt-3">
      <div className="col-lg-12">
        <h4 className="mb-5 cardtitlecolor text-center">
          {t("InstallmentOptions")}
        </h4>
      </div>
      <div className="row justify-content-center">
        <div className="col-lg-12 py-5">
          <Swiper
            slidesPerView={3}
            spaceBetween={30}
            freeMode={true}
            pagination={{ clickable: true }}
            modules={[FreeMode, Pagination]}
            className="mySwiper"
            breakpoints={{
              0: { slidesPerView: 1 },
              640: { slidesPerView: 4 },
              1024: { slidesPerView: 5 },
            }}
          >
            {InstallmentData.blogs.map((item) => (
              <SwiperSlide key={item.id} className="mb-5 text-center">
                <img
                  src={item.images}
                  alt={item.alt}
                  width={170}
                  height={50}
                  style={{ objectFit: "contain" }}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className="col-lg-8">
          <table className="table border table-bordered text-center ">
            <thead>
              <tr>
                <th scope="col" className="w-33 align-content-center">
                  {t("Taksit")}
                </th>
                <th scope="col" className="w-33 align-content-center">
                  {t("TaksitOranı")}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td> {t("Ücretsiz!")}</td>
              </tr>
              <tr>
                <td>2</td>
                <td>{t("Ücretsiz!")}</td>
              </tr>
              <tr>
                <td>3</td>
                <td>{t("Ücretsiz!")}</td>
              </tr>
              <tr>
                <td>6</td>
                <td>%12,2</td>
              </tr>
              <tr>
                <td>9</td>
                <td>%20,24</td>
              </tr>
              <tr>
                <td>12</td>
                <td>%29,34</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default InstallmentOptions;
